module.exports = __webpack_public_path__ + "img/home_hero.53038e34.jpg";